// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SyncMonitorView_view__73Yn4 {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 60px;
}

.SyncMonitorView_headerCard__0DaTJ,
.SyncMonitorView_calendarCard__-4xms,
.SyncMonitorView_detailCard__E\\+vzV,
.SyncMonitorView_listCard__GT2oz {
  margin-bottom: 20px;
}

.SyncMonitorView_toolbar__mHweV {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
}

.SyncMonitorView_viewToggleInline__3E4oF {
  display: flex;
  border: 1px solid #dbdbdb;
  border-radius: 14px;
  overflow: hidden;
  align-self: center;
}

.SyncMonitorView_viewBtn__N8z0b {
  padding: 4px 14px;
  background: #fff;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #838383;
}
.SyncMonitorView_viewBtn__N8z0b:hover:not(.SyncMonitorView_viewBtnActive__va8Ef) {
  background: #f4f5f7;
}

.SyncMonitorView_viewBtnActive__va8Ef {
  background: var(--primary-color);
  color: #fff;
  font-weight: 600;
}

.SyncMonitorView_overview__4F5TM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  padding: 5px 10px;
  background: #f4f5f7;
  border-radius: 3px;
  font-size: 12px;
  color: #838383;
  margin-left: auto;
}

.SyncMonitorView_overviewItem__8mhMQ {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.SyncMonitorView_overviewItem__8mhMQ strong {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary-color);
  font-family: monospace;
}

.SyncMonitorView_overviewLabel__pws5t {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
  margin-top: 2px;
}

.SyncMonitorView_viewToggle__TDAuJ {
  display: flex;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  overflow: hidden;
}

.SyncMonitorView_toggleBtn__ftFgs {
  padding: 5px 10px;
  background: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #838383;
}
.SyncMonitorView_toggleBtn__ftFgs:hover {
  background: #f4f5f7;
}

.SyncMonitorView_toggleActive__4O34R {
  background: #dbdbdb;
  color: #838383;
  font-weight: 600;
}

.SyncMonitorView_picker__\\+ywJR {
  padding: 5px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  font-size: 14px;
  color: #838383;
  background: #fff;
  cursor: pointer;
}
.SyncMonitorView_picker__\\+ywJR:focus {
  outline: none;
  border-color: #acacac;
}

.SyncMonitorView_controlsWrap__ACO2u {
  border-top: 1px solid #f4f5f7;
  padding-top: 10px;
  margin-bottom: 10px;
}

.SyncMonitorView_legendWrap__MMiSh {
  border-top: 1px solid #f4f5f7;
  padding-top: 10px;
}

.SyncMonitorView_bodyGrid__bazje {
  display: grid;
  grid-template-columns: 40% minmax(0, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}
@media (max-width: 1100px) {
  .SyncMonitorView_bodyGrid__bazje {
    grid-template-columns: 1fr;
  }
}

.SyncMonitorView_calendarCard__-4xms,
.SyncMonitorView_detailCard__E\\+vzV {
  margin-bottom: 0;
  min-width: 0;
}

.SyncMonitorView_detailPlaceholder__RboI7 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  padding: 30px;
  color: #acacac;
  font-size: 14px;
  text-align: center;
}

.SyncMonitorView_listCardContent__va\\+x- {
  padding: 0;
}

.SyncMonitorView_emptyMsg__85hFw {
  margin: 10px 0;
  color: #acacac;
  font-size: 14px;
}

.SyncMonitorView_loaderWrap__S\\+GGk {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.SyncMonitorView_tagsWrap__WTkJu {
  margin-top: 10px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/views/SyncMonitorView/SyncMonitorView.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;AAFF;;AAOA;;;;EAIE,mBCJS;ADAX;;AASA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SCbS;EDcT,mBCfS;ADSX;;AASA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AANF;;AASA;EACE,iBAAA;EACA,gBExBM;EFyBN,YAAA;EACA,eAAA;EACA,eAAA;EACA,cEjCS;AF2BX;AAQE;EACE,mBEvCO;AFiCX;;AAUA;EACE,gCElDQ;EFmDR,WErCM;EFsCN,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SChDS;EDiDT,iBAAA;EACA,mBEvDS;EFwDT,kBC5Dc;ED6Dd,eAAA;EACA,cEvDS;EFwDT,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAPF;AASE;EACE,eAAA;EACA,gBAAA;EACA,2BE5EM;EF6EN,sBAAA;AAPJ;;AAWA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cE7ES;EF8ET,eAAA;AARF;;AAWA;EACE,aAAA;EACA,yBAAA;EACA,kBC1Fc;ED2Fd,gBAAA;AARF;;AAWA;EACE,iBAAA;EACA,gBEpFM;EFqFN,YAAA;EACA,eAAA;EACA,eCrFe;EDsFf,cE7FS;AFqFX;AAUE;EACE,mBEnGO;AF2FX;;AAYA;EACE,mBEvGS;EFwGT,cEtGS;EFuGT,gBAAA;AATF;;AAYA;EACE,iBAAA;EACA,yBAAA;EACA,kBCpHc;EDqHd,eCvGe;EDwGf,cE/GS;EFgHT,gBE3GM;EF4GN,eAAA;AATF;AAWE;EACE,aAAA;EACA,qBEtHO;AF6GX;;AAaA;EACE,6BAAA;EACA,iBC/HU;EDgIV,mBC3HS;ADiHX;;AAaA;EACE,6BAAA;EACA,iBCrIU;AD2HZ;;AAeA;EACE,aAAA;EACA,yCAAA;EACA,SCvIS;EDwIT,mBCxIS;AD4HX;AAcE;EANF;IAOI,0BAAA;EAXF;AACF;;AAcA;;EAEE,gBAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aC9JW;ED+JX,cE9JS;EF+JT,eCvJe;EDwJf,kBAAA;AAXF;;AAgBA;EACE,UAAA;AAbF;;AAkBA;EACE,cAAA;EACA,cE7KS;EF8KT,eCtKe;ADuJjB;;AAkBA;EACE,aAAA;EACA,uBAAA;EACA,aCpLY;ADqKd;;AAkBA;EACE,gBCtLS;EDwLT,mBCxLS;ADwKX","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.view {\n  width: 100%;\n  box-sizing: border-box;\n  padding: $padding-xl ($padding-xxl + $padding-l);\n}\n\n// ─── Card spacing ────────────────────────────────────────────────────────────\n\n.headerCard,\n.calendarCard,\n.detailCard,\n.listCard {\n  margin-bottom: $margin-l;\n}\n\n// ─── Area 1 — Header (toolbar + legend) ──────────────────────────────────────\n\n.toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: $margin-l;\n  margin-bottom: $margin-m;\n}\n\n.viewToggleInline {\n  display: flex;\n  border: 1px solid $grey-200;\n  border-radius: 14px;\n  overflow: hidden;\n  align-self: center;\n}\n\n.viewBtn {\n  padding: 4px 14px;\n  background: $white;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  color: $grey-400;\n\n  &:hover:not(.viewBtnActive) {\n    background: $grey-100;\n  }\n}\n\n.viewBtnActive {\n  background: $primary;\n  color: $white;\n  font-weight: 600;\n}\n\n.overview {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: $margin-l;\n  padding: $padding-s $padding-m;\n  background: $grey-100;\n  border-radius: $border-radius;\n  font-size: 12px;\n  color: $grey-400;\n  margin-left: auto;\n}\n\n.overviewItem {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n\n  strong {\n    font-size: 16px;\n    font-weight: 700;\n    color: $primary;\n    font-family: monospace;\n  }\n}\n\n.overviewLabel {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n  margin-top: 2px;\n}\n\n.viewToggle {\n  display: flex;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  overflow: hidden;\n}\n\n.toggleBtn {\n  padding: $padding-s $padding-m;\n  background: $white;\n  border: none;\n  cursor: pointer;\n  font-size: $base-font-size;\n  color: $grey-400;\n\n  &:hover {\n    background: $grey-100;\n  }\n}\n\n.toggleActive {\n  background: $grey-200;\n  color: $grey-400;\n  font-weight: 600;\n}\n\n.picker {\n  padding: $padding-s $padding-m;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  font-size: $base-font-size;\n  color: $grey-400;\n  background: $white;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n    border-color: $grey-300;\n  }\n}\n\n.controlsWrap {\n  border-top: 1px solid $grey-100;\n  padding-top: $padding-m;\n  margin-bottom: $margin-m;\n}\n\n.legendWrap {\n  border-top: 1px solid $grey-100;\n  padding-top: $padding-m;\n}\n\n// ─── Area 2 — Calendar (40%) | Detail (60%) ──────────────────────────────────\n\n.bodyGrid {\n  display: grid;\n  grid-template-columns: 40% minmax(0, 1fr);\n  gap: $margin-l;\n  margin-bottom: $margin-l;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.calendarCard,\n.detailCard {\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.detailPlaceholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n  padding: $padding-xl;\n  color: $grey-300;\n  font-size: $base-font-size;\n  text-align: center;\n}\n\n// ─── Area 3 — Status days list ───────────────────────────────────────────────\n\n.listCardContent {\n  padding: 0;\n}\n\n// ─── Shared ──────────────────────────────────────────────────────────────────\n\n.emptyMsg {\n  margin: $margin-m 0;\n  color: $grey-300;\n  font-size: $base-font-size;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xxl;\n}\n\n.tagsWrap {\n  margin-top: $margin-m;\n  // Same gap above the divider as the other blocks (see .controlsWrap).\n  margin-bottom: $margin-m;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `SyncMonitorView_view__73Yn4`,
	"headerCard": `SyncMonitorView_headerCard__0DaTJ`,
	"calendarCard": `SyncMonitorView_calendarCard__-4xms`,
	"detailCard": `SyncMonitorView_detailCard__E+vzV`,
	"listCard": `SyncMonitorView_listCard__GT2oz`,
	"toolbar": `SyncMonitorView_toolbar__mHweV`,
	"viewToggleInline": `SyncMonitorView_viewToggleInline__3E4oF`,
	"viewBtn": `SyncMonitorView_viewBtn__N8z0b`,
	"viewBtnActive": `SyncMonitorView_viewBtnActive__va8Ef`,
	"overview": `SyncMonitorView_overview__4F5TM`,
	"overviewItem": `SyncMonitorView_overviewItem__8mhMQ`,
	"overviewLabel": `SyncMonitorView_overviewLabel__pws5t`,
	"viewToggle": `SyncMonitorView_viewToggle__TDAuJ`,
	"toggleBtn": `SyncMonitorView_toggleBtn__ftFgs`,
	"toggleActive": `SyncMonitorView_toggleActive__4O34R`,
	"picker": `SyncMonitorView_picker__+ywJR`,
	"controlsWrap": `SyncMonitorView_controlsWrap__ACO2u`,
	"legendWrap": `SyncMonitorView_legendWrap__MMiSh`,
	"bodyGrid": `SyncMonitorView_bodyGrid__bazje`,
	"detailPlaceholder": `SyncMonitorView_detailPlaceholder__RboI7`,
	"listCardContent": `SyncMonitorView_listCardContent__va+x-`,
	"emptyMsg": `SyncMonitorView_emptyMsg__85hFw`,
	"loaderWrap": `SyncMonitorView_loaderWrap__S+GGk`,
	"tagsWrap": `SyncMonitorView_tagsWrap__WTkJu`
};
export default ___CSS_LOADER_EXPORT___;
